import { createStore, persist, createTypedHooks } from "easy-peasy";
import { user, UserModel } from "./models/user";
import { dashboard, AdminDashboardModel } from "./models/dashboard";
import { modals, AdminModalsModel } from "./models/modals";
import { transfer, EmployeeTransferModel } from "./models/transfers";
import { livechat, LiveChatModel } from "./models/livechat";
export interface AppModel {
  user: UserModel;
  dashboard: AdminDashboardModel;
  modals: AdminModalsModel;
  transfer: EmployeeTransferModel;
  livechat: LiveChatModel;
}

const storeModel: AppModel = {
  user: persist(user),
  dashboard: persist(dashboard),
  modals: persist(modals),
  // note: transfer is not persisted
  transfer,
  // note: livechat is not persisted
  livechat,
};

const store = createStore(storeModel);

const typedHooks = createTypedHooks<AppModel>();

export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;

export default store;
